<template>
  <v-container>
    <h1 class="text-center">Belohnungsanfragenverlauf</h1>
    <v-toolbar flat>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>

    <!-- Desktop: Data Table -->
    <v-data-table
      v-if="!$vuetify.breakpoint.smAndDown"
      :search="search"
      :headers="headers"
      :items="rewards"
      sort-by="calories"
      class="elevation-1"
    >
      <template v-slot:[`item.lr_reedem_tstmp`]="{ item }">
        <div v-if="item.lr_reedem_tstmp">
          {{ new Date(item.lr_reedem_tstmp * 1000).toLocaleString('de-De') }}
        </div>
        <i v-else>-</i>
      </template>
      <template v-slot:[`item.lr_decision_tstmp`]="{ item }">
        <div v-if="item.lr_decision_tstmp">
          {{ new Date(item.lr_decision_tstmp * 1000).toLocaleString('de-De') }}
        </div>
        <i v-else>-</i>
      </template>
      <template v-slot:[`item.lr_decision_mod`]="{ item }">
        <div v-if="item.lr_decision_mod">{{ item.lr_decision_mod }}</div>
        <i v-else>-</i>
      </template>
    </v-data-table>

    <!-- Mobile: Card List -->
    <template v-else>
      <v-card
        v-for="item in mobileItems"
        :key="item.lr_id || item.lr_reedem_tstmp"
        class="mb-3"
        outlined
      >
        <v-card-title class="py-2 text-subtitle-1 font-weight-bold">
          {{ item.lr_title }}
        </v-card-title>
        <v-card-subtitle class="pb-0">
          <v-chip x-small class="mr-1">{{ item.username }}</v-chip>
        </v-card-subtitle>
        <v-card-text class="pt-2">
          <div class="caption">
            <span class="grey--text">Angefragt: </span>
            <span v-if="item.lr_reedem_tstmp">{{ new Date(item.lr_reedem_tstmp * 1000).toLocaleString('de-De') }}</span>
            <i v-else>-</i>
          </div>
          <div class="caption mt-1">
            <span class="grey--text">Entschieden: </span>
            <span v-if="item.lr_decision_tstmp">{{ new Date(item.lr_decision_tstmp * 1000).toLocaleString('de-De') }}</span>
            <i v-else>-</i>
          </div>
          <div class="caption mt-1">
            <span class="grey--text">Mod: </span>
            <span v-if="item.lr_decision_mod">{{ item.lr_decision_mod }}</span>
            <i v-else>-</i>
          </div>
        </v-card-text>
      </v-card>
      <v-alert v-if="mobileItems.length === 0" type="info" class="mt-2">
        Keine Einträge gefunden.
      </v-alert>
    </template>
  </v-container>
</template>

<script>
import BackendService from '@/services/BackendService';

export default {
  data: () => ({
    search: '',
    rewards: [],
    headers: [
      { text: 'Belohnung', value: 'lr_title', align: 'center' },
      { text: 'User', value: 'username', align: 'center' },
      { text: 'Angefragt', value: 'lr_reedem_tstmp', align: 'center' },
      { text: 'Angenommen/Abgelehnt', value: 'lr_decision_tstmp', align: 'center' },
      { text: 'Mod', value: 'lr_decision_mod', align: 'center' },
    ],
  }),
  computed: {
    mobileItems() {
      if (!this.search) return this.rewards;
      const s = this.search.toLowerCase();
      return this.rewards.filter((r) => (r.lr_title && r.lr_title.toLowerCase().includes(s))
        || (r.username && r.username.toLowerCase().includes(s))
        || (r.lr_decision_mod && r.lr_decision_mod.toLowerCase().includes(s)));
    },
  },
  mounted() {
    BackendService.loadRewardRequestsHistory().then((data) => {
      this.rewards = data.data;
    });
  },
};
</script>
